angular.module('unergie.main')
.controller('invoicesCutoffCtrl', ($scope, $location, $stateParams, NgTableParams, FilterMapping, DataAccessSearch, MS, ApiBilling, AlertManager, TableGeneratorService, ErrorCatcher) => {
    $scope.invoiceStatuses = FilterMapping.invoiceStatuses

    $scope.invoices = {
        refreshing: false,
        show: {},
        counts: [10, 25, 50, 100],
        columns: {
            'selector': { label: 'Sel.', mode: 'filter_only' },
            'id': { label: 'ID', mode: 'search_operator', mandatory: true },
            'id_contract': { label: 'Contrat', mode: 'search_wildcard', mandatory: true },
            'status': { label: 'Status', mode: 'search_operator', mandatory: true },
            'period_start_date': { label: 'Début', mode: 'search_date' },
            'period_end_date': { label: 'Fin', mode: 'search_date' },
            'reading_ids': { label: 'Relèves', mode: 'hidden' },
            'error_code': { label: 'Code erreur', mode: 'hidden' },
            'cutoff_date': { label: 'Date du cutoff', mode: 'search_date', strictDate: true },
            'version': { label: 'Version', mode: 'hidden' },
            'contractElec.category.name': { label: 'Paquet facturier', mode: 'search_wildcard' },
            'contractElec.category.organization': { label: 'Org.', mode: 'search_wildcard' },
            'contractElec.account.brand': { label: 'Compte', mode: 'search_wildcard' },
            'contractElec.account.customer_id': { label: 'customer_id', mode: 'hidden' },
        },
    }

    const lastMonthMoment = moment().add(-1, 'month')
    $scope.cutoffMonth = Number(($stateParams.month) || lastMonthMoment.format('M'))
    $scope.cutoffYear = Number($stateParams.year || lastMonthMoment.year())

    $scope.months = [
        { value: 1, label: 'Janvier' },
        { value: 2, label: 'Février' },
        { value: 3, label: 'Mars' },
        { value: 4, label: 'Avril' },
        { value: 5, label: 'Mai' },
        { value: 6, label: 'Juin' },
        { value: 7, label: 'Juillet' },
        { value: 8, label: 'Août' },
        { value: 9, label: 'Septembre' },
        { value: 10, label: 'Octobre' },
        { value: 11, label: 'Novembre' },
        { value: 12, label: 'Décembre' },
    ]

    $scope.changeCutoffDate = () => {
        const cutoff_date = moment(`${$scope.cutoffYear}-${$scope.cutoffMonth}`, 'YYYY-M').endOf('month').format('DD/MM/YYYY')
        if ($scope.invoices.instance) {
            const existingFilter = $scope.invoices.instance.filter()
            $scope.invoices.instance.filter = () => _.assign(existingFilter, { cutoff_date })
        } else {
            $scope.invoices.instance = {
                page: () => 1,
                count: () => 25,
                sorting: () => ({}),
                filter: () => _.assign({ cutoff_date }, _.clone($location.search())),
            }
        }
        $scope.refreshInvoices()
    }


    $scope.processing = (invoice) => _.some([
        $scope.massValuating,
        invoice.valuating,
    ])

    $scope.toggleSelected = function (invoice, e) {
        e.preventDefault()
        e.stopPropagation()
        invoice.selected = !invoice.selected
    }

    $scope.selectAll = () =>
        _.forEach($scope.invoices.instance.data, (c) => {
            c.selected = true
        })


    $scope.deSelectAll = () =>
        _.forEach($scope.invoices.instance.data, (c) => {
            c.selected = false
            return true
        })

    $scope.getValuables = () =>
        _.filter($scope.invoices.instance.data, 'selected')

    $scope.getSelectedNumber = () => _.countBy($scope.invoices.instance.data, 'selected').true || 0

    $scope.refreshInvoice = function (i) {
        i.refreshing = true
        return $scope.refreshInvoiceReadings(i).then(() => {
            i.fetched = true
            i.refreshing = false
        })
    }

    $scope.toggleExpand = function (invoice) {
        if (!invoice.refreshing) {
            invoice.expanded = !invoice.expanded
            if (!invoice.fetched) {
                $scope.refreshInvoice(invoice)
            }
        }
    }

    // CALLS
    $scope.refreshInvoiceReadings = (invoice) => {
        if (!invoice.reading_ids) {
            return Promise.resolve()
        }
        return DataAccessSearch({ in: [`id=${invoice.reading_ids.ids.join(',')}`], orderBy: '-end_date' })
        .searchPaginated({ resource: 'readings' }).$promise.then((readingsResult) => {
            let readings = _.filter(_.orderBy(readingsResult.results, '-end_date'), (r) => r.start_date !== null)
            _.each(readings, (r) => {
                r.cons = r.consumption || r.value - (r.last_value || 0)
                r.dates = `${moment(r.start_date).format('DD/MM/YYYY')} ⮕ ${moment(r.end_date).format('DD/MM/YYYY')}`
            })
            readings = _.groupBy(readings, (r) => r.dates + r.index_nature)
            readings = _.map(readings, (v) => {
                const days = moment(v[0].end_date).diff(moment(v[0].start_date), 'days')
                const cons = _.sumBy(v, 'cons')
                return {
                    index_nature: v[0].index_nature,
                    dates: v[0].dates,
                    days,
                    index: _.sumBy(v, (e) => `${e.temp_class} : ${e.last_value} ⮕ ${e.value} `),
                    cons,
                    consDaily: (cons / days).toFixed(2),
                    detailsCons: (v.length > 1 ? `(${_.sumBy(v, (e) => `${e.temp_class} : ${e.cons} `)})` : ''),
                }
            })
            invoice.readingsTP = new NgTableParams({ count: 12 }, {
                counts: [],
                dataset: readings,
            })
        }).catch(ErrorCatcher)
    }

    $scope.valuate = (invoice, e) => {
        e.preventDefault()
        e.stopPropagation()
        if ($scope.processing(invoice)) {
            return
        }
        invoice.valuating = true
        return ApiBilling.valuateInvoiceCutoff({ id_invoice: invoice.id }, {}).$promise.then((result) => {
            AlertManager.success(`Valorisation OK : ${result.message}`)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.valuating = false
            $scope.refreshInvoices()
        })
    }

    $scope.massValuate = () => {
        if ($scope.massValuating) {
            return
        }
        $scope.massValuating = true
        return ApiBilling.massOperation({ operation: 'valuate', cutoff: true }, _.map($scope.getValuables(), 'id')).$promise.then((result) => {
            AlertManager.success(`Batch 'valuate' traité avec succès`)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.massValuating = false
            $scope.refreshInvoices()
        })
    }

    // TABLE
    const transform = (invoices) => {
        _.each(invoices, (invoice) => {
            invoice.readingCollapsed = true
            invoice.estiCollapsed = true
        })
    }

    $scope.refreshInvoices = () => {
        TableGeneratorService.getTable($scope.invoices, 'invoices-cutoff', null, transform, { orderBy: '-id' })
    }

    $scope.changeCutoffDate()
})
